import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Team } from 'api/models';
import { TeamsStore } from './store';

export const slice = createSlice({
  name: '@@TEAMS',
  initialState: TeamsStore.empty(),
  reducers: {
    load: (state: TeamsStore) => TeamsStore.load()(state),
    putAll: (state: TeamsStore, { payload: teams }: PayloadAction<Team[]>) =>
      TeamsStore.putAll(teams)(),
    add: (state: TeamsStore, { payload: team }: PayloadAction<Team>) =>
      TeamsStore.add(team)(state),
    remove: (state: TeamsStore, { payload: teamId }: PayloadAction<number>) =>
      TeamsStore.remove(teamId)(state),
    update: (state: TeamsStore, { payload: team }: PayloadAction<Team>) =>
      TeamsStore.update(team)(state),
  },
});
